import { Divider } from "antd";
import React from "react";

import "./styles.scss";

type CustomDividerProps = {
  type?: "vertical" | "horizontal";
};

const CustomDivider = ({ type = "horizontal" }: CustomDividerProps) => {
  return <Divider className={`CustomDivider ${type}`} type={type} />;
};

export default CustomDivider;
